// extracted by mini-css-extract-plugin
export default {"fr-view":"MSTeamsNavigation_fr-view__+JPCx","button":"MSTeamsNavigation_button__tYG7J"};